import "react-app-polyfill/stable";

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import { ThemeProvider } from "./contexts/ThemeContext";
import { ErrorBoundary } from "react-error-boundary";

const container = document.getElementById("root");
const root = createRoot(container!);

const FallbackUI = () => <div>Oops, something went wrong</div>;

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <ErrorBoundary
        fallback={<FallbackUI />}
        onError={(error, info) => console.error(error, info)}
      >
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </BrowserRouter>
);
